import React from 'react'
import { errorClassName } from '../../utils/form'

import styles from './FormField.module.css'

export default ({ className = '', type, name, note, error, children, radioDisabled=false  }) =>
  <section className={`formField ${styles.formField} ${className}`}>
    {name
      ? <label className="label">
          {name}
        </label>
      : null}
    {type
      ? <label className={`${type} ${errorClassName(error)}`} style={{ cursor: radioDisabled ? 'not-allowed' : 'default' }}>
          {children}
        </label>
      : children}
    {error
      ? <label className="note-error">
          <em className="invalid">
            {error}
          </em>
        </label>
      : null}
    {note
      ? <label className="note">
          {note}
        </label>
      : null}
  </section>
